<script>
import { BEmbed } from "bootstrap-vue";

export default {
  extends: BEmbed
};
</script>